import axios from "axios";
import Config from "./Config";
import AppConfig from "./AppConfig";

function getAccessToken() {
  try {
    const tokenString = localStorage.getItem("token");
    if (!tokenString || tokenString === "undefined") return null;
    return JSON.parse(tokenString)?.access_token ?? null;
  } catch {
    return null;
  }
}

// ── Order Forms API instance ──────────────────────────────────────────────────
const apiClient = axios.create({ baseURL: Config.baseApiUrl });

apiClient.interceptors.request.use((config) => {
  const token = getAccessToken();
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.clear();
      window.location.href = `${AppConfig.orderFormPath}/login`;
    }
    return Promise.reject(error);
  }
);

// ── Security API instance ─────────────────────────────────────────────────────
export const securityApiClient = axios.create({ baseURL: Config.baseSecurityUrl });

securityApiClient.interceptors.request.use((config) => {
  const token = getAccessToken();
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

securityApiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401 && !error.config.url.includes("login")) {
      localStorage.clear();
      window.location.href = `${AppConfig.orderFormPath}/login`;
    }
    return Promise.reject(error);
  }
);

// ── Global interceptors on default axios (covers all legacy files) ────────────
axios.interceptors.request.use((config) => {
  const token = getAccessToken();
  if (token && !config.headers.Authorization) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.clear();
      window.location.href = `${AppConfig.orderFormPath}/login`;
    }
    return Promise.reject(error);
  }
);

export default apiClient;
